import { useMemo } from 'react';
import {
  EnhancedGroupedSection,
  FormSchemaConfig,
} from '../../types/form/schema.types';
import { FormState } from '../../types';
import {
  OVERTIME_FIELD_LABELS,
  OVERTIME_SECTION_KEYS,
  OVERTIME_SECTION_TITLES,
  YES_NO_OPTIONS,
} from './constants';

export const useOvertimeApprovalFinanceConfirmationSchema = (
  formState: FormState
): FormSchemaConfig => {
  return useMemo<FormSchemaConfig>(() => {
    const isEditAllowed =
      formState.data?.userAssignedSections?.includes(
        OVERTIME_SECTION_KEYS.financeConfirmation
      ) === true;

    const isSectionComplete =
      formState.completedSections?.includes(
        OVERTIME_SECTION_KEYS.financeConfirmation
      ) || false;

    const isDisabled = isSectionComplete || !isEditAllowed;

    const financeConfirmationSection: EnhancedGroupedSection = {
      layout: 'single',
      isGrouped: true,
      isGroupedAccordion: false,
      sections: [
        {
          title: {
            text: OVERTIME_SECTION_TITLES.financeConfirmation,
          },
          layout: 'single',
          fields: [
            {
              type: 'radio',
              name: 'confirmation',
              label: OVERTIME_FIELD_LABELS.confirmation,
              options: [...YES_NO_OPTIONS],
              required: true,
              validate: (value) =>
                !value
                  ? `Please select ${OVERTIME_FIELD_LABELS.confirmation}`
                  : undefined,
              disabled: isDisabled,
            },
          ],
        },
      ],
      extras: { grouped: true, evenSpacing: true },
    };

    return {
      sections: [financeConfirmationSection],
      dependencies: {
        showWhen: [
          {
            field: OVERTIME_SECTION_KEYS.lineManager,
          },
        ],
      },
    };
  }, [formState]);
};
